import { useEffect, useRef } from 'react'
import { useTracking } from 'contexts/Tracking/TrackingContext'

const usePageFocusTracking = (
  eventName: string,
  eventProperties: any = {},
  options: any = {}
): void => {
  const { tracking } = useTracking()
  const eventNameRef = useRef(eventName)
  const eventPropertiesRef = useRef(eventProperties)
  const skip: boolean = options?.skip || false

  useEffect(() => {
    eventNameRef.current = eventName
    eventPropertiesRef.current = eventProperties
  }, [eventName, eventProperties])

  useEffect(() => {
    const mountedAt = Date.now()
    return () => {
      if (!skip) {
        const unmountedAt = Date.now()
        const secondsOnPage = ((unmountedAt - mountedAt) / 1000).toFixed(2)
        const properties = Object.assign(eventPropertiesRef.current || {}, {
          secondsOnPage: secondsOnPage
        })
        tracking.log(eventNameRef.current, properties)
      }
    }
  }, [skip, tracking])
}

export default usePageFocusTracking
